export default {
	completedOn: 'Vehicle history check completed on {date}.',
	disclaimer:
		'All data provided by CAP HPI and Vcheck. All warranties disclaimed. You should always carry out your own checks.',
	source: 'Source: HPI and Vcheck',
	title: 'HPI history check',
};
